import React from 'react';
import {connect} from 'react-redux';

import {findProfile, editModel} from '../actions';

const ProfilePage = (props) => {
    return <div> {
        !props.profile &&
        <section className="form">
            <div className="container container-md">
                <div>
                    <div className="form-header">
                        <div className="text-center">
                            <h1>Din profil</h1>
                        </div>
                        <div className="form-text text-muted text-center">
                            <p>Ange ditt personnummer och den e-postadress du använde vid registreringen.</p>
                        </div>
                    </div>
                    <form>
                        <div className="form-group">
                            <label>Personnummer</label>
                            <input type="text" className="form-control" placeholder="ÅÅÅÅMMDD-XXXX" value={props.ssn}
                                   onChange={props.onLoginChange.bind(null, 'ssn')}/>
                        </div>
                        <div className="form-group">
                            <label>E-postadress</label>
                            <input type="email" className="form-control" placeholder="info@epost.se" value={props.email}
                                   onChange={props.onLoginChange.bind(null, 'email')}/>
                        </div>
                        {props.invalid && <div className="alert alert-warning">
                            Ditt personnummer eller e-postadress är felformaterat, var vänlig kontrollera dina uppgifter
                        </div>}
                        {props.status > 0 && <div className="alert alert-warning">
                            Det gick inte att hitta din profil, var vänlig och kontrollera dina uppgifter
                        </div>}
                        <div className="form-footer text-center">
                            <button type="submit" onClick={props.onFindProfile} disabled={!props.email || !props.ssn}
                                    className="btn btn-success btn-lg">Fortsätt <i
                                className="fa-light fa-arrow-right"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    }
    {
        props.profile && <div>

            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h1>Din Profil</h1>
                        </div>
                    </div>
                    <br />
                    {props.invalid && <div className="alert alert-warning">
                        Var vänlig och kontrollera att följande fält är korrekt ifyllda:
                        <ul className="list-unstyled">
                            {props.invalidData && props.invalidData.map(data => {
                                let text = null;
                                switch (data) {
                                    case 'terms':
                                        text = 'Det krävs att du godkänner användarvillkoren'
                                        break;
                                    case 'ssn':
                                        text = 'Personnummer: Ange ett giltigt personnummer'
                                        break;
                                    case 'name':
                                        text = 'Namn: Ange ett namn'
                                        break;
                                    case 'phone':
                                        text = 'Telefon: Ange ett telefonnummer utan mellanslag'
                                        break;
                                    case 'email':
                                        text = 'Epost: Ange en giltig epostadress'
                                        break;
                                    case 'address':
                                        text = 'Adress: Ange en adress'
                                        break;
                                    case 'postal_code':
                                        text = 'Postnummer: Ange fem siffror utan mellanslag'
                                        break;
                                    case 'city':
                                        text = 'Postort: Ange en postort'
                                        break;
                                    case 'location':
                                        text = 'Plats: Ange plats (vid undertecknandet)'
                                        break;
                                    case 'signature':
                                        text = 'Signatur: Teckna din signatur'
                                        break;
                                    case 'payment':
                                        text = 'Betalning: Ange din kompletta betalningsinformation'
                                        break;
                                    case 'image':
                                        text = 'Bild: Ogiltig profilbild, välj en ny bild'
                                        break;

                                }
                                if (text) {
                                    return <li>{text}</li>
                                }
                            })}
                        </ul>
                    </div>}
                    {props.invalidUnknown && <div className="alert alert-danger">
                        Ett oväntat fel uppstod, om problemet kvarstår var vänlig och kontakta oss. (Felkod: {props.errorCode})
                    </div>}

                    <table className="table contract-table">
                        <thead>
                        <tr>
                            <th><h3>Modelluppgifter</h3></th>
                            <th className="text-right">
                                <button className="btn btn-secondary" onClick={props.toggleEditMode}>{props.editMode ? 'Avbryt' : 'Ändra uppgifter'}</button>
                                {props.editMode && <button className="btn btn-success ml-3" onClick={props.saveForm}>Spara</button>}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="text-right">Personnummer</td><td>{props.profile.ssn}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Namn</td>
                            {props.editMode ? <td><input type="text" value={props.profile.name} onChange={props.onFieldChange.bind(null, 'name')} className="form-control" /></td> :  <td>{props.profile.name}</td>}
                        </tr>
                        <tr>
                            <td className="text-right">Address</td>
                            {props.editMode ? <td><input type="text" value={props.profile.address} onChange={props.onFieldChange.bind(null, 'address')} className="form-control" /></td> :  <td>{props.profile.address}, {props.profile.postal_code} {props.profile.city}</td>}
                        </tr>

                        {props.editMode &&
                        <tr>
                            <td className="text-right">Postnummer</td>
                            <td><input type="text" value={props.profile.postal_code} onChange={props.onFieldChange.bind(null, 'postal_code')} className="form-control" /></td>
                        </tr>}

                        {props.editMode &&
                        <tr>
                            <td className="text-right">Stad</td>
                           <td><input type="text" value={props.profile.city} className="form-control" onChange={props.onFieldChange.bind(null, 'city')} /></td>
                        </tr>}

                        <tr>
                            <td className="text-right">Telefon</td>
                            {props.editMode ? <td><input type="text" value={props.profile.phone} onChange={props.onFieldChange.bind(null, 'phone')} className="form-control" /></td> :  <td>{props.profile.phone}</td>}
                        </tr>
                        <tr>
                            <td className="text-right">E-postadress</td>
                            {props.editMode ? <td><input type="text" value={props.profile.email} onChange={props.onFieldChange.bind(null, 'email')} className="form-control" /></td> :  <td>{props.profile.email}</td>}
                        </tr>
                        <tr>
                            <td className="text-right">Beskrivning</td>
                            {props.editMode ? <td><textarea className="form-control" onChange={props.onFieldChange.bind(null, 'description')} rows={3}>{props.profile.description}</textarea></td> :  <td>{props.profile.description}</td>}
                        </tr>

                        {props.editMode ?
                        <tr>
                            <td className="text-right">Porträtt</td>
                            <td>{!props.profile.image && <div className="form-control">
                                <hr />
                                <label htmlFor={ 'profile-register' } className="profile-pick btn btn-success">Välj eller ta en bild</label>
                                <input id={ 'profile-register' } type="file" name={ 'profile-register' } className="profile-pick-file d-none"  onChange={props.onPhoto.bind(null)} />
                            </div>}
                                {props.profile.image && <div className="form-control"><img src={props.profile.image} />
                                    <hr />
                                    <button onClick={props.newProfile.bind(null)} className="btn btn-success">Byt bild</button>
                                </div> }
                            </td>
                        </tr>
                            :
                            <tr>
                                <td className="text-right">Porträtt</td>
                                <td><img src={props.profile.image}  /></td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>

            {props.profile.contracts && props.profile.contracts.length == 0 &&
            <div className="alert alert-info">Du har inga påskrivna kontrakt ännu</div>}
            {props.profile.contracts && props.profile.contracts.length > 0 &&
            <ul className="list">
                <li className="list-header">
                    <div className="row align-items-center">
                        <div className="col">Dina kontrakt</div>
                        <div className="col-3">Betalning</div>
                        <div className="col-2">Underskrift</div>
                        <div className="col-2">Status</div>
                    </div>
                </li>
                {props.profile.contracts && props.profile.contracts.map((contract) => {

                    var contractStatus = 'Obehandlad';
                    switch (contract.status) {
                        case 1:
                            contractStatus = 'Betald';
                            break;
                        case 2:
                            contractStatus = 'Arkiverad';
                            break;
                        case 3:
                            contractStatus = 'Ogiltig';
                            break;

                    }

                    if (contract.status !== 3) {
                        return <li>
                            <div className="row align-items-center">
                                <div className="col">
                                    <h2>{contract.identity}</h2>
                                    <p className="small">{contract.name} &nbsp;|&nbsp; {contract.location}</p>
                                    <p className="small">{contract.date} ({contract.expiration})</p>
                                </div>
                                <div className="col-3">
                                    <p className="small">{contract.payment.clearing} &nbsp;|&nbsp; {contract.payment.account}</p>
                                    <p className="small">{contract.payment.bank}</p>
                                </div>
                                <div className="col-2">
                                    <img className="img-fluid" src={contract.signature} />
                                </div>
                                <div className="col-2">
                                    {contractStatus}
                                </div>
                            </div>
                        </li>
                    }

                })}
            </ul>}
        </div>
    }
    </div>;

}

export default connect(state => state.profileState, (dispatch) => {
    return {
        onLoginChange: (field, e) => {
            dispatch({
                type: 'PROFILE_LOGIN_CHANGE',
                field: field,
                value: e.target.value
            })
        },
        onFieldChange: (field, e) => {
            dispatch({
                type: 'PROFILE_FIELD_CHANGE',
                field: field,
                value: e.target.value
            })
        },
        onFindProfile: (e) => {
            e.preventDefault();
            findProfile(dispatch);
        },
        toggleEditMode: (e) => {
            e.preventDefault();
            dispatch({
                type: 'PROFILE_EDIT_MODE'
            })
        },
        saveForm: (e) => {
            e.preventDefault();
            editModel(dispatch);
        },
        newProfile: (e) => {
            dispatch({
                type: 'PROFILE_FIELD_CHANGE',
                field: 'image',
                value: ''
            })
        },
        onPhoto: ( e) => {
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onloadend = function() {
                var orgImage = new Image;
                orgImage.onload = () => {
                    // create an off-screen canvas
                    var canvas = document.createElement('canvas'),
                        ctx = canvas.getContext('2d');

                    var maxWidth = 600;
                    var maxHeight = 600;

                    var ratio = maxWidth / orgImage.width;
                    var newW = maxWidth;
                    var newH = orgImage.height * ratio;

                    if (newH > maxHeight) {
                        ratio = maxHeight / orgImage.height;
                        newH = maxHeight;
                        newW = orgImage.width * ratio;
                    }

                    // set its dimension to target size
                    canvas.width = newW;
                    canvas.height = newH;

                    // draw source image into the off-screen canvas:
                    ctx.drawImage(orgImage, 0, 0, newW, newH);

                    // encode image to data-uri with base64 version of compressed image
                    var image = canvas.toDataURL('image/jpeg', 0.8);

                    dispatch({
                        type: 'PROFILE_FIELD_CHANGE',
                        field: 'image',
                        value: image
                    })
                };
                orgImage.src = reader.result;


            }
            reader.readAsDataURL(file);
        }
    }
})(ProfilePage);